import { createApp } from "vue";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/css/main.css';
import '@/assets/css/barce.css';
import App from "./App.vue";
import router from "./router";
import  {store}  from './store/index'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import DisableAutocomplete from 'vue-disable-autocomplete';
const app=createApp(App);
app.use(store);
app.use(router).mount("#app");
